module.exports = __webpack_public_path__ + "img/eatsforyou.967d51f7.svg";